<div class="flex flex-col gap-1 border border-rounded-sm p-2 rounded bg-slate-100" [ngClass]="{ 'border-slate-300' : !hasValue, 'border-ponder-link' : hasValue }">
    <div class="flex flex-row gap-2 items-center">
        <label class="text-xs sm:text-sm grow" [ngClass]="{ 'text-slate-700' : !hasValue, 'text-ponder-link' : hasValue }">{{ type }}</label>
        @if (hasValue) {
            <button (click)="onToggleLogicalMode()" class="rounded shadow-sm text-white bg-ponder-link hover:bg-ponder-linkhover p-[2px] pl-2 pr-2 text-xs font-mono w-[6ch]">
                @if (logicalAnd) {
                    AND
                } @else {
                    OR
                }
            </button>
            <button (click)="onClear()">
                <svg-icon [svgIcon]="closeSvgIcon" [small]="true" class="fill-none stroke-ponder hover:stroke-ponder-link"></svg-icon>
            </button>
        }
    </div>
    <div class="flex flex-row gap-1 items-center">
        <button 
            (click)="onToggleWhite()" 
            class="flex items-center justify-center border-2 border-transparent rounded-[999px] size-7 bg-no-repeat" 
            style="background-image: url('https://images.pondertcg.com/magic/symbol/W.svg');" 
            [ngClass]="{ 'border-ponder-link' : white, 'border-transparent' : !white }"></button>

        <button 
            (click)="onToggleBlue()" 
            class="flex items-center justify-center border-2 border-transparent rounded-[999px] size-7 bg-no-repeat" 
            style="background-image: url('https://images.pondertcg.com/magic/symbol/U.svg');" 
            [ngClass]="{ 'border-ponder-link' : blue, 'border-transparent' : !blue }"></button>

        <button 
            (click)="onToggleBlack()" 
            class="flex items-center justify-center border-2 border-transparent rounded-[999px] size-7 bg-no-repeat" 
            style="background-image: url('https://images.pondertcg.com/magic/symbol/B.svg');" 
            [ngClass]="{ 'border-ponder-link' : black, 'border-transparent' : !black }"></button>

        <button 
            (click)="onToggleRed()" 
            class="flex items-center justify-center border-2 border-transparent rounded-[999px] size-7 bg-no-repeat" 
            style="background-image: url('https://images.pondertcg.com/magic/symbol/R.svg');" 
            [ngClass]="{ 'border-ponder-link' : red, 'border-transparent' : !red }"></button>

        <button 
            (click)="onToggleGreen()" 
            class="flex items-center justify-center border-2 border-transparent rounded-[999px] size-7 bg-no-repeat" 
            style="background-image: url('https://images.pondertcg.com/magic/symbol/G.svg');" 
            [ngClass]="{ 'border-ponder-link' : green, 'border-transparent' : !green }"></button>

        <button 
            (click)="onToggleColorless()" 
            class="flex items-center justify-center border-2 border-transparent rounded-[999px] size-7 bg-no-repeat" 
            style="background-image: url('https://images.pondertcg.com/magic/symbol/C.svg');" 
            [ngClass]="{ 'border-ponder-link' : colorless, 'border-transparent' : !colorless }"></button>
    </div>
</div>